import React from 'react'
import PeopleCard from '../PeopleProfileCard';
import img1 from '../../../Images/btp_Lohith.jpeg'
import img2 from '../../../Images/btp_Shivank.jpeg'
import img3 from '../../../Images/btp_Shriyansh.jpeg'
import img4 from '../../../Images/btp_Sindhura.jpeg'

const createElements = () => {
  const elements = [];
  const PeopleImagesUrl = [img1,img2,img3,img4];
  const PeopleName = ['C.Lohith Veer', 'Shivank Goyal', 'Shriyansh Tamboli', 'Sindhura Rokkala'];
  const PeopleEmailId = ['',];
  const PeopleDescription = [``];
  const Link = [
    "https://www.linkedin.com/in/lohith-veer-chinthalapudi-059609324/",
    "https://www.linkedin.com/in/shivankgoyal23/",
    "https://www.linkedin.com/in/shriyansh-tamboli-66158028b/",
    "https://www.linkedin.com/in/sindhura-rokkala-848850298/"
  ];


  for (var i=0;i<PeopleName.length;i++){
      elements.push(<PeopleCard key = {i} peopleImagesUrl = {PeopleImagesUrl[i]} peopleName = {PeopleName[i]} peopleEmailId = {PeopleEmailId[i]} peopleDescription = {PeopleDescription[i]} link={Link[i]}/>)
  }
  return elements
}


const Btech = () => {
  return (
    <div className="album py-2">
      <div className="row">
      {createElements()}
    </div>
  </div>
  )
}

export default Btech